<template>
  <a
    data-toggle="modal"
    @click="$parent.$parent.$parent.editFunction(data.id)"
    :class="options.class"
    :data-target="options.target"
    ><i class="ag-icon ag-icon_edit" data-toggle="tooltip" title="Edit"></i
  ></a>
</template>

<script>
export default {
  name: "tableEditComponent",
  props: {
    data: {
      type: Array,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
  },
};
</script>

<style scoped></style>
